/* eslint-disable no-console */
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useAffiliate } from 'hooks/webapi';
import { INTRO } from 'Router/routes';
import { containsHttps } from 'utils/containsHttps';

export default function AffiliatePage() {
  const { fetchAffiliate } = useAffiliate();
  const navigate = useNavigate();
  const location = useLocation();
  const { provider } = useParams();

  useEffect(() => {
    const fetchAffiliateSetCookie = async () => {
      fetchAffiliate({ provider, queryString: location.search })
        .then((fetchedAffiliate) => {
          console.error('Affiliate cookie was set successfully');
          if (fetchedAffiliate?.redirectUrl) {
            if (containsHttps(fetchedAffiliate?.redirectUrl)) {
              window.location.href = fetchedAffiliate?.redirectUrl;
              return;
            }

            navigate(fetchedAffiliate.redirectUrl);
            return;
          }

          navigate(INTRO);
        })
        .catch((error) => {
          console.error(error);
          navigate(INTRO);
        });
    };

    fetchAffiliateSetCookie();
  }, []);

  return null;
}
